var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGamesradar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "-0.5 5.5 46.5 25",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.7 24.8c-.2 1-.6 1.7-1.2 2.5-.6.7-1.5 1.4-2.7 2-1.2.4-2.7.7-4.7.7a11 11 0 0 1-2.6-.3c-.8-.2-1.6-.5-2.3-1-.7-.4-1.3-1-1.8-1.7s-.8-1.5-.8-2.4h4.6c.3.8.7 1.4 1.3 1.8.7.3 1.4.5 2.2.5 1.3 0 2.3-.4 3-1.2.5-.8.8-1.8.8-3v-2.3c-.6 1-1.3 1.6-2.2 2a7 7 0 0 1-3 .7c-1.3 0-2.4-.2-3.3-.7-1-.4-1.7-1-2.3-1.8a8 8 0 0 1-1.3-2.8 13 13 0 0 1 0-6.5c.4-1 .9-1.9 1.5-2.7a6.8 6.8 0 0 1 5.4-2.5 7 7 0 0 1 3 .6c.8.4 1.6 1.1 2.1 2.1V6.5H17v16l-.3 2.3m-6.5-5.7c.6-.2 1-.6 1.3-1 .3-.5.6-1 .7-1.5l.3-1.8c0-.7 0-1.3-.2-2a5 5 0 0 0-.7-1.6c-.3-.5-.7-.9-1.2-1.2-.5-.2-1.1-.4-1.9-.4a3 3 0 0 0-1.7.4 4 4 0 0 0-1.2 1L5 12.7l-.2 1.8c0 .7 0 1.3.2 1.9.1.6.3 1.1.6 1.6s.7.9 1.2 1.2c.5.3 1 .4 1.8.4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8 6.4v3.2a6 6 0 0 1 5.5-3.6l1 .1v4.4a9.9 9.9 0 0 0-1.7-.2 5 5 0 0 0-2.2.4 4.5 4.5 0 0 0-2.2 2.9l-.2 2.2v7.7h-4.7v-17h4.5z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6 12.5h6v-6h5v6h6v5h-6v6h-5v-6h-6z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGamesradar);
export default __webpack_public_path__ + "static/media/gamesradar.7ed1f8cc91bf385d3788c6771206e614.svg";
export { ForwardRef as ReactComponent };